import React, { useRef } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import { Virtuoso } from 'react-virtuoso'
import _ from 'lodash'
import { AnimatePresence } from "framer-motion"

import { TextField, ListTile, Button, Icon, Animation } from 'components'
import { FaCheck, FaCaretRight } from 'react-icons/fa'

import { pageContext, sectionContext } from 'context'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: 0,
    width: '15rem'
}

const selectedStyle = {
    backgroundColor: 'var(--focus-color)',
    color: 'white'
}

const iconStyle = {
    backgroundColor: 'transparent',
    margin: 0,
    padding: '0rem',
}

const Container = styled.div`
    width: ${props => props.styles.width};
    border-radius: 5px;
    padding: ${props => props.styles.padding};
    display: flex;
    flex-direction: column;
    background-color: ${props => props.styles.backgroundColor};
    max-height: 20rem;
    height: min-content;
    overflow-y: auto;
`

const Placeholder = styled.div`
    padding: 0.2rem;
`

const Wrapper = styled.div`
    border: ${props => `2px solid ${props.selected ? 'var(--focus-color)' : 'transparent'}`};
    border-radius: 5px;
    display: flex;
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1rem minmax(0, max-content) 1fr 1rem;
    grid-column-gap: 0.5rem;
    align-items: center;
    padding: 0.5rem;
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Text = styled.div`
    font-weight: bold;
    font-size: 0.8rem;
`

const PageSelector = props => {
    const {
        pageID,
        onSelect,
        styles,
        selected,
        disableSubmitButton
    } = props
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS())
    const user = useSelector((state) => state.auth.user)
    const [selectedPage, setPage] = React.useState(pageID)
    const [n, setIndex] = React.useState(-1)

    // Refs
    const containerRef = React.useRef()
    const optionsRef = React.useRef([])


    // const getBlocks = () => {
    //     let pageIDs = [user['inboxID']]
    //     pageIDs.push(...user['activePages'])
    //     let blocks = []

    //     // Generate blocks
    //     Object.values(pageIDs).map(pID => {
    //         // Page block
    //         const page = data['pages'][pID]
    //         if(!page){return}
    //         const icon = <Icon value={page.icon ? page.icon.value : null} type={page.icon ? page.icon.type : null}
    //                         styles={iconStyle}/>
    //         blocks.push(<ListTile icon={icon} text={page['page_name']} 
    //                         onSelect={()=> setPage(page['pageID'])}
    //                         styles={selectedPage === page['pageID'] && selectedStyle}/>)
    //     })
    //     // Placeholder if got nothing
    //     blocks.length === 0 && blocks.push(<Placeholder>No active pages</Placeholder>)

    //     let options = []
    //     Object.values(pageIDs).map(pID => {
    //         const page = data['pages'][pID]
    //         if(!page){ return }

    //         options.push({
    //             title: page['page_name'],
    //             value: page['pageID'],
    //             icon: <Icon value={page.icon ? page.icon.value : null} 
    //                     type={page.icon ? page.icon.type : null}
    //                     styles={iconStyle}/>,
    //             onSelect: () => setPage(page['pageID'])
    //         })
    //     })

    //     const placeholder = options.length === 0 && <Placeholder>No active pages</Placeholder>

        
    //     return blocks
    // }

    // const blocks = getBlocks()

    // Create options
    let pageIDs = [user['inboxID']]
    pageIDs.push(...user['activePages'])

    let options = []
    Object.values(pageIDs).map(pID => {
        const page = data['pages'][pID]
        if(!page){ return }

        options.push({
            title: page['page_name'],
            value: page['pageID'],
            icon: <Icon value={page.icon ? page.icon.value : null} 
                    type={page.icon ? page.icon.type : null}
                    styles={iconStyle} size='1rem'/>,
            onSelect: () => !disableSubmitButton ? setPage(page['pageID']) : onSelect && onSelect(page['pageID'])
        })
    })
    const placeholder = options.length === 0 && <Placeholder>No active pages</Placeholder>

    return (
        <Container styles={updatedStyle}>
            {/* {blocks} */}
            {options.map((option,index) => (
                <Wrapper selected={n === index}
                    ref={el => optionsRef.current[index] = el}>
                    <Row onClick={option['onSelect']} styles={option['styles']}>
                        {option['icon']}
                        <Text>{option['title']}</Text>
                        <span/>
                        {selected && ((option['value'] === selected | (Array.isArray(selected) && selected.includes(option['value'])))) ? <FaCheck style={{ color: 'var(--focus-color)' }}/> : null}
                    </Row>
                </Wrapper>
            ))}    
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                {!disableSubmitButton && <Button text='Apply' onSelect={() => onSelect(selectedPage)} 
                    styles={{
                        width: 'min-content',
                        backgroundColor:'var(--focus-color)',
                        margin:'0.2rem 0',
                        fontWeight: 'bolder',
                        color: 'white'
                    }}/>}
            </div>
        </Container>
    )
}

export default PageSelector